export const AuthError = {
  ROLE_REQUIRED: 'Please choose role',
  FIRST_NAME_REQUIRED: 'Please enter your first name',
  LAST_NAME_REQUIRED: 'Please enter your last name',
  USER_NAME_REQUIRED: 'Please enter your user name',
  STUDY_REQUIRED: 'Please enter study number',
  DATE_OF_BIRTH_REQUIRED: 'Please enter date of birth',
  MEDICAL_RECORD_REQUIRED: 'Please enter medical record number',
  RACE_REQUIRED: 'Please enter your race',
  EMAIL_REQUIRED: 'Please enter email',
  EMAIL_INVALID: 'Email is incorrect',
} as const;
